import {BONUS_EMITTER_POOL_SIZE} from '../../ClickerGame.constants';
import {destroyBonusConfig} from './destroy-bonus.config';
import {DI_TOKENS} from '@/di/di.tokens';
import {ContainerChild, Sprite} from 'pixi.js';

import {injected} from 'brandi';

import {BaseComponent, IGameWorld} from '@specials/gcs-engine';
import {ParticleEmitter} from '@specials/particle-emitter';

import {ClickerGameAssetsLoader} from '../../ClickerGameAssetsLoader';
import {EmitterPoolComponent} from '../../components/EmitterPoolComponent';
import {EmittersContainer} from '../EmittersContainer/EmittersContainer';
import {EmittersContainerViewComponent} from '../EmittersContainer/EmittersContainerViewComponent';

export class BonusDestroyEffectEmitterComponent extends BaseComponent {
  private container?: EmittersContainerViewComponent;
  private emitterPoolComponent?: EmitterPoolComponent;

  constructor(private readonly assetsLoader: ClickerGameAssetsLoader) {
    super();
  }

  public onAddToGameObject(): void {
    this.emitterPoolComponent = this.gameObject.getComponent(EmitterPoolComponent);
  }

  public onAddToWorld(world: IGameWorld): void {
    this.container = world.getGameObject(EmittersContainer)?.getComponent(EmittersContainerViewComponent);

    this.emitterPoolComponent?.init(this.createEmitter, BONUS_EMITTER_POOL_SIZE);
  }

  private createEmitter = (): ParticleEmitter => {
    if (!this.container) throw new Error('app is not defined');

    const emitter = new ParticleEmitter<ContainerChild>(this.container.view, this.createSprite, {
      emitterConfig: {spawnParticlesPerWave: 40, autoStart: false},
      particleConfig: destroyBonusConfig(),
    });

    return emitter;
  };

  private createSprite = (): Sprite => {
    const sprite = new Sprite(this.assetsLoader.bundle.defaultParticle);
    sprite.anchor.set(0.5);
    return sprite;
  };
}

injected(BonusDestroyEffectEmitterComponent, DI_TOKENS.clickerGameAssetsLoader);
